import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const angleDoubleRight: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M4.578-4.687a.27.27 0 0 1 .078.187.24.24 0 0 1-.078.172L.938-.688a.25.25 0 0 1-.188.079.23.23 0 0 1-.172-.078l-.39-.391a.23.23 0 0 1-.079-.172q-.002-.106.079-.187L3.25-4.5.188-7.578a.23.23 0 0 1-.079-.172q-.002-.106.079-.187l.39-.391c.05-.05.11-.078.172-.078a.27.27 0 0 1 .188.078zm3 0a.27.27 0 0 1 .078.187.24.24 0 0 1-.078.172l-3.64 3.64a.25.25 0 0 1-.188.079.23.23 0 0 1-.172-.078l-.39-.391a.23.23 0 0 1-.079-.172q-.002-.106.079-.187L6.25-4.5 3.188-7.578a.23.23 0 0 1-.079-.172q-.002-.106.079-.187l.39-.391c.05-.05.11-.078.172-.078a.27.27 0 0 1 .188.078zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.11 8.406)"
    />
  ),
  svgProps: {
    height: "7.797",
    width: "7.547",
  }
};

export const angleDoubleUp: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.328-1.937a.27.27 0 0 1 .078.187.24.24 0 0 1-.078.172l-.39.39a.25.25 0 0 1-.188.079.23.23 0 0 1-.172-.078L4.5-4.25 1.438-1.187a.25.25 0 0 1-.188.078.23.23 0 0 1-.172-.078l-.39-.391a.23.23 0 0 1-.079-.172q-.002-.105.079-.187l3.64-3.641c.05-.05.11-.078.172-.078a.27.27 0 0 1 .188.078zm0-3a.27.27 0 0 1 .078.187.24.24 0 0 1-.078.172l-.39.39a.25.25 0 0 1-.188.079.23.23 0 0 1-.172-.078L4.5-7.25 1.438-4.187a.25.25 0 0 1-.188.078.23.23 0 0 1-.172-.078l-.39-.391a.23.23 0 0 1-.079-.172q-.002-.106.079-.187l3.64-3.641c.05-.05.11-.078.172-.078a.27.27 0 0 1 .188.078zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.61 8.656)"
    />
  ),
  svgProps: {
    height: "7.797",
    width: "7.547",
  }
};